import { types } from 'mobx-state-tree';


export default types.model('ShippingCountry', {
	CountryName: types.string,
    CountryCode: types.string,
    CountryGroup: types.string,
  
}).views(self => ({
  
})).actions(self => ({
	
}));
